export default {
  CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE',
  FETCH_APPLICATION_ERROR: 'FETCH_APPLICATION_ERROR',
  FETCHING_APPLICATION: 'FETCHING_APPLICATION',
  HIDE_MEMBER_2: 'HIDE_MEMBER_2',
  RECEIVED_APPLICATION: 'RECEIVED_APPLICATION',
  SET_TRIANGLE_SWAP: 'SET_TRIANGLE_SWAP',
  SHOW_APARTMENT2: 'SHOW_APARTMENT2',
  SHOW_DETAILS2: 'SHOW_DETAILS2',
  SHOW_MEMBER2: 'SHOW_MEMBER2',

  UPDATE_APPLICATION: 'UPDATE_APPLICATION',
};



// WEBPACK FOOTER //
// ./src/features/Application/constants.js